import { BaseModel } from '@app/shared/models/base';
import { DrFileMeta, DrFileMetaList } from '@app/shared/models/dr-file';

export enum ClientMediaType {
    LOGO = 'logo',
    META_GRAPHIC = 'metagraphic',
    STAMP = 'stamp',
    SIGNATURE = 'signature'
}

export class MediaContainer extends BaseModel {
    public logo: DrFileMetaList;
    public metagraphic: DrFileMetaList;
    public stamp: DrFileMetaList;
    public signature: DrFileMetaList;

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            logo: new DrFileMetaList({
                document_type: ClientMediaType.LOGO,
                entries: json && json.logo ? json.logo : null
            }),
            metagraphic: new DrFileMetaList({
                document_type: ClientMediaType.META_GRAPHIC,
                entries: json && json.metagraphic ? json.metagraphic : null
            }),
            stamp: new DrFileMetaList({
                document_type: ClientMediaType.STAMP,
                entries: json && json.stamp ? json.stamp : null
            }),
            signature: new DrFileMetaList({
                document_type: ClientMediaType.SIGNATURE,
                entries: json && json.signature ? json.signature : null
            })
        });
    }

    public addFile(file: DrFileMeta, type: ClientMediaType): void {
        if (type === ClientMediaType.LOGO) {
            this.logo.addFileMetaData(file);
        } else if (type === ClientMediaType.META_GRAPHIC) {
            this.metagraphic.addFileMetaData(file);
        } else if (type === ClientMediaType.SIGNATURE) {
            this.signature.addFileMetaData(file);
        } else if (type === ClientMediaType.STAMP) {
            this.stamp.addFileMetaData(file);
        }
    }

    public replaceFile(file: DrFileMeta, type: ClientMediaType): void {
        let daArray;

        if (type === ClientMediaType.LOGO) {
            daArray = this.logo;
        } else if (type === ClientMediaType.META_GRAPHIC) {
            daArray = this.metagraphic;
        } else if (type === ClientMediaType.SIGNATURE) {
            daArray = this.signature;
        } else if (type === ClientMediaType.STAMP) {
            daArray = this.stamp;
        }

        const idx = this.getFileIndex(daArray.entries, file);

        if (idx > -1) {
            daArray.entries[idx] = file;
        }
    }

    public removeFile(file: DrFileMeta, type: ClientMediaType): void {
        if (type === ClientMediaType.LOGO) {
            this.logo.removeFileMetaData(file);
        } else if (type === ClientMediaType.META_GRAPHIC) {
            this.metagraphic.removeFileMetaData(file);
        } else if (type === ClientMediaType.SIGNATURE) {
            this.signature.removeFileMetaData(file);
        } else if (type === ClientMediaType.STAMP) {
            this.stamp.removeFileMetaData(file);
        }
    }

    public getNextOrderOf(type: ClientMediaType): number {
        if (type === ClientMediaType.LOGO) {
            return this.logo.nextOrder;
        } else if (type === ClientMediaType.META_GRAPHIC) {
            return this.metagraphic.nextOrder;
        } else if (type === ClientMediaType.SIGNATURE) {
            return this.signature.nextOrder;
        } else if (type === ClientMediaType.STAMP) {
            return this.stamp.nextOrder;
        }
    }

    private getFileIndex(list: DrFileMeta[], file: DrFileMeta) {
        const found = list.find(f => {
            return f.filename === file.filename && !f.id;
        });

        return found ? list.indexOf(found) : -1;
    }
}
